import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import axios from 'axios';
import ENDPOINT from '../../../data/ENDPOINT';
import SecurityHeaders from '../../../data/SecurityHeaders';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Navbar, Nav, Spinner } from 'react-bootstrap';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import { Box, Typography } from '@mui/material';

const CollegeDashboard = () => {
  const { college_id } = useParams();
  const { user } = useContext(AuthContext);
  const [students, setStudents] = useState(null);
  const [loading, setLoading] = useState(true);
  const [college_logo, setCollegeLogo] = useState(null);
  const [college_background, setCollegeBackground] = useState(null);

  const getCollegeStudents = async () => {
    const data = new FormData();
    data.append('college_id', college_id);
    if (user && user.SessionId) {
      data.append('session', user.SessionId);
    }
    try {
      setLoading(true);
      const response = await axios.post(
        `${ENDPOINT}get-college-students.php`,
        data,
        SecurityHeaders
      );
      if (response.data.status === 'success') {
        setStudents(response.data.students);
        setCollegeLogo(response.data.college_logo);
        setCollegeBackground(response.data.college_background);
      } else {
        console.error('Error fetching students');
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const [college, setCollege] = useState(null);
  const getCollegeDetails = async () => {
    const data = new FormData();
    data.append('college_id', college_id);
    if (user && user.SessionId) {
      data.append('session', user.SessionId);
    }
    try {
      setLoading(true);
      const response = await axios.post(
        `${ENDPOINT}get-college-details.php`,
        data,
        SecurityHeaders
      );
      if (response.data.status === 'success') {
      setCollege(response.data.college);
      } else {
        console.error('Error fetching college details');
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCollegeStudents();
    getCollegeDetails();
  }, []);
  // console.log(college);
  const progress = 50;
  return (
    <div className=" bg-light">     
  <div className="mb-4 col-12 college-bg2" style={{ height: '40vh'}}>
            <div className="  d-flex align-items-center container" style={{ height: '100%' }}>
     <div className=' col-12' >
       <div  className='col-11 col-sm-11 col-md-4 col-lg-4' >
      <img
       className='w-100'
            // style={{ width: '100px', height: '100px', borderRadius: '50%', border: '2px solid white' }}
            src={college&&college.college_logo || 'default-logo.png'} 
            alt="College Logo"
          />
      </div>
       
          <div className="" >
            <h4 className="fw-bold text-white">{ college&&college.institute_name}</h4> 
            <h5 className=" text-white mb-1">{college&&college.location}</h5> 
            <h5 className="text-white">College ID: {college&&college.college_id}</h5>
          </div></div>
            </div>
          </div>
        <Container className="py-4">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
          <Spinner animation="border" variant="primary" />
            </div>
          ) : (
           <>
        
  
          <Row className="g-4" style={{ flexWrap: 'wrap-reverse' }}>

            <Col lg={8}>
              <h3 className="mb-4 fw-semibold text-dark">Students</h3>
              {students && students.length > 0 ? (
                students.map((student, index) => (
                  <Card key={index} className="mb-3 shadow-sm">
                    <Card.Body>
                      <div className="d-flex justify-content-between flex-wrap align-items-center mb-3">
                        <div className="d-flex align-items-center col-12 col-sm-12 col-md-8">
                          <Avatar
                            sx={{ width: { xs: 48, md: 56 }, height: { xs: 48, md: 56 } }}
                            src={student.profile_pic}
                          />
                          <div className="ms-3">
                            <h6 className="text-start">
                              {student.first_name} {student.last_name}
                            </h6>
                            <h6 className="text-start">
                              Attendance: {student.attendance_count}
                            </h6>

                            <h6 className="mt-2 text-secondary text-start truncate2 truncate sm-truncate2">
                              {student.course_title}
                            </h6>
                          </div>
                        </div>
                        <div className="text-end col-12 col-sm-12 col-md-2">
                          <div className='d-flex  justify-content-center' >
                         <div className='text-center' >   <h6 className="fw-medium   ">Progress</h6>
                            <Box position="relative" display="inline-flex" className="mt-1">
                              <CircularProgress
                                size={30}
                                variant="determinate"
                                value={student.progress}
                              />
                              <Box
                                top={0}
                                left={0}
                                bottom={0}
                                right={0}
                                position="absolute"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Typography
                                  variant="caption"
                                  component="div"
                                  color="textSecondary"
                                  style={{ fontSize: '0.6rem' }} 
                                >
                                  {`${Math.round(student.progress)}%`}
                                </Typography>
                              </Box>
                            </Box></div>
                          </div>
                          <Row xs={10} sm={10} md={2} className="d-flex justify-content-center mt-2">
                            <Button variant="primary" size="sm" className='col-10' >
                              View Details
                            </Button>
                          </Row>
                        </div>
                      </div>

                

                    </Card.Body>
                  </Card>
                ))
              ) : (
                <p className="text-muted">No students found.</p>
              )}
            </Col>

            {/* Courses Sidebar */}
            <Col lg={4}>
              <h3 className="mb-4 fw-semibold text-dark">Courses</h3>
              <Row xs={2} className="g-3">
                {[
                  {
                    src: 'https://skillsuprise.com/data/course-images/ethical-hacking.png',
                    alt: 'Ethical Hacking Course',
                  },
                  {
                    src: 'https://skillsuprise.com/data/course-images/cloud-computing.png',
                    alt: 'Cloud Computing Course',
                  },
                  {
                    src: 'https://skillsuprise.com/data/course-images/ethical-hacking.png',
                    alt: 'Ethical Hacking Course',
                  },
                  {
                    src: 'https://skillsuprise.com/data/course-images/cloud-computing.png',
                    alt: 'Cloud Computing Course',
                  },
                ].map((course, index) => (
                  <Col key={index}>
                    <Avatar
                      variant="square"
                      className="w-100"
                      sx={{ height: { xs: 100, md: 140 } }}
                      src={course.src}
                      alt={course.alt}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row></>
        )}
      </Container>
    </div>
  );
};

export default CollegeDashboard;